import { render, staticRenderFns } from "./Loginphone2.vue?vue&type=template&id=189abe36&scoped=true&"
import script from "./Loginphone2.vue?vue&type=script&lang=js&"
export * from "./Loginphone2.vue?vue&type=script&lang=js&"
import style0 from "./Loginphone2.vue?vue&type=style&index=0&id=189abe36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189abe36",
  null
  
)

export default component.exports